export enum Role {
  ADMIN = 'ADMIN',
  BILLING_ADMIN = 'BILLING_ADMIN',
  BOOKING = 'BOOKING',
  SENIOR_BOOKING = 'SENIOR_BOOKING',
  CARRIER = 'CARRIER',
  ADMIN_CUSTOMER = 'ADMIN_CUSTOMER',
  CUSTOMER = 'CUSTOMER',
  EXTERNAL = 'EXTERNAL',
  GATE = 'GATE',
  GATE_BOOKING = 'GATE_BOOKING',
  NONE = ''
}
